module.exports = __webpack_public_path__ + "img/promo-signup-check.dc8c1ea4.svg";